import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDemo } from "@/contexts/DemoContext";
import { useTranslation } from "react-i18next";

interface DemoBannerProps {
  /** Kept for API compatibility — no longer used. */
  topOffset?: number;
}

/**
 * Floating "return to demo menu" button shown in the bottom-right
 * whenever a demo scenario is active. The full top banner has been
 * removed in favor of this minimal control.
 */
export default function DemoBanner(_: DemoBannerProps) {
  const { isInDemo, currentScenario, exitDemo } = useDemo();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!isInDemo || !currentScenario) return null;

  return (
    <button
      type="button"
      onClick={async () => {
        await exitDemo();
        navigate("/demo-v3/scenario-bilan");
      }}
      aria-label={t("demoV3.banner.menuAria")}
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 pl-4 pr-5 py-2.5 rounded-full text-white text-sm font-medium shadow-xl bg-gradient-to-r from-[#7C3AED] to-[#2DD4BF] hover:shadow-2xl hover:scale-[1.03] transition-all animate-in fade-in slide-in-from-bottom-2"
    >
      <X className="w-4 h-4" />
      <span>{t("demoV3.banner.menu")}</span>
    </button>
  );
}
